// apps/web/src/ui/scale.ts
import { usePageScale } from "@/ui/usePageScale";

export const BASE_W = 1264 as const;

/**
 * 공통 헤더용 스케일 훅
 * - 내부에서 androidViewport(readAndroidCssViewport)를 사용
 * - window.Android.getViewWidthPx / getViewHeightPx / getWebViewSize 활용
 */
export function useScale() {
    const { r, s, px } = usePageScale({ baseW: BASE_W });
    return { r, s, px };
}
